"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createCancelToken = exports.isCancel = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var CancelToken = _axios.default.CancelToken;

var isCancel = function (e) {
  return _axios.default.isCancel(e);
};

exports.isCancel = isCancel;

var createCancelToken = function () {
  var source = CancelToken.source();
  return {
    token: source.token,
    source: source,
    cancel: function () {
      source.cancel();
    },
    isCancel: function (e) {
      return isCancel(e);
    }
  };
};
/**
 * An `Http` object is an adapter that performs HTTP requests using the underlying request library.
 */


exports.createCancelToken = createCancelToken;

var Http =
/** @class */
function () {
  /**
   * Initializes an instance with the baseUrl and header configuration. The `baseUrl` value will
   * be prepended to all relative urls made with this instance, whereas absolute urls will be
   * passed through without prefixing.
   *
   * @param baseUrl
   * @param headers
   */
  function Http(baseUrl, headers) {
    this._client = _axios.default.create({
      baseURL: baseUrl,
      headers: (0, _utils.extend)({
        'Content-Type': 'application/json'
      }, headers)
    });
  }
  /**
   * Performs a GET request for the relative or absolute url.
   *
   * @param {string} url
   * @param {*} [opts=undefined]
   * @returns
   * @memberof Http
   */


  Http.prototype.get = function (url, opts) {
    if (opts === void 0) {
      opts = undefined;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, e_1;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , this._client.get(url, (0, _utils.extend)({
              cancelToken: new CancelToken(function (c) {
                _this._source = c;
              })
            }, opts))];

          case 1:
            res = _a.sent();
            return [2
            /*return*/
            , res];

          case 2:
            e_1 = _a.sent();

            if (_axios.default.isCancel && _axios.default.isCancel(e_1)) {
              console.info('Request canceled', e_1.message); // eslint-disable-line no-console
            } else {
              throw e_1;
            }

            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            , null];
        }
      });
    });
  };
  /**
   * Performs a POST request for the relative or absolute url.
   *
   * @param {string} url
   * @param {*} data
   * @param {*} [opts=undefined]
   * @returns
   * @memberof Http
   */


  Http.prototype.post = function (url, data, opts) {
    if (opts === void 0) {
      opts = undefined;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, e_2;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , this._client.post(url, data, (0, _utils.extend)({
              cancelToken: new CancelToken(function (c) {
                _this._source = c;
              })
            }, opts))];

          case 1:
            res = _a.sent();
            return [2
            /*return*/
            , res];

          case 2:
            e_2 = _a.sent();

            if (_axios.default.isCancel && _axios.default.isCancel(e_2)) {
              console.info('Request canceled', e_2.message); // eslint-disable-line no-console
            } else {
              throw e_2;
            }

            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            , null];
        }
      });
    });
  };

  Http.prototype.cancel = function () {
    if (this._source) {
      this._source();
    }
  };
  /**
   * A class method that performs a request to an absolute url.
   *
   * @param url
   * @param opts
   */


  Http.request = function (url, opts) {
    if (opts === void 0) {
      opts = undefined;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , _axios.default.get(url, opts)];

          case 1:
            res = _a.sent();
            return [2
            /*return*/
            , res];
        }
      });
    });
  };

  return Http;
}();

var _default = Http;
exports.default = _default;